

















































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {ScrollButton, InputWings} from "wings-ui-components";
import ImportPoolNumbers from "@/components/Settings/Pools/ImportPoolNumbers.vue";
import {notifyDelete, notifyError, notifyWarning} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {PoolNumberItem} from "@/store/settings/pools/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({components: {ScrollButton, ImportPoolNumbers, InputWings}})
export default class PoolNumbers extends BaseItemsPage<PoolNumberItem>  {
  @Action('getPoolNumbers') actionGetPoolNumbers: any;
  @Action('updatePoolNumber') actionUpdatePoolNumber: any;
  @Action('deletePoolNumbers') actionDeletePoolNumbers: any;
  @Getter('poolNumbers') poolNumbersResponse: any;
  @Action('actionLog') actionLog: any;

  is_show_import = false;
  selectedIds: number[] = [];
  is_show_filter = false;
  filterClone: { msisdn?: string, page_number?: number } = {};
  runFilter: boolean = false;
  private logObject: ActionLog = {};
  private originalMsisdnMap: { [key: number]: string } = {};
  private editingId: number | null = null;

  getData(): PoolNumberItem[] {
    return this.poolNumbersResponse;
  }

  onSelect(items: PoolNumberItem[]): void {
    this.selectedIds = items.filter(i => i.id !== undefined).map(i => i.id as number)
  }

  async onDelete(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (!isConfirm) return;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Removal",
        action_status: "success",
        object_type: "Page",
        addititional_info: getTranslatedParams({id: this.$route.params.id, number: this.selectedIds.length})
      }
      await this.actionLog(this.logObject);
      await this.actionDeletePoolNumbers({id: Number(this.$route.params.id), originators_ids: this.selectedIds});
      this.selectedIds = [];
      await this.actionGetPoolNumbers({ id: Number(this.$route.params.id) });
    } catch (e) {
      await this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(e);
    }
  }

  onStartEdit(item: PoolNumberItem & { onEdit?: boolean }): void {
    if (this.editingId !== null && this.poolNumbersResponse) {
      const prev = this.poolNumbersResponse.find((r: PoolNumberItem) => r.id === this.editingId);
      if (prev) {
        this.onCancelEdit(prev);
      }
    }
    const key = Number(item.id);
    this.originalMsisdnMap[key] = item.msisdn;
    this.editingId = key;
    this.$set(item, 'onEdit', true);
  }

  async onSaveItem(item: PoolNumberItem & { onEdit?: boolean }): Promise<void> {
    if (!item) return;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: 'Editing',
        action_status: 'success',
        object_type: 'Page',
        addititional_info: getTranslatedParams({ id: item.id, msisdn: item.msisdn })
      };
      await this.actionLog(this.logObject);
      await this.actionUpdatePoolNumber({ id: Number(this.$route.params.id), numberId: Number(item.id), msisdn: item.msisdn });
      this.$set(item, 'onEdit', false);
      this.editingId = null;
      await this.actionGetPoolNumbers({ id: Number(this.$route.params.id) });
    } catch (error) {
      const key = Number(item.id);
      if (this.originalMsisdnMap[key] !== undefined) {
        item.msisdn = this.originalMsisdnMap[key];
      }
      this.$set(item, 'onEdit', true);
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    } finally {
      item.onEdit = false
    }
  }

  onCancelEdit(item: PoolNumberItem & { onEdit?: boolean }): void {
    const key = Number(item.id);
    if (this.originalMsisdnMap[key] !== undefined) {
      item.msisdn = this.originalMsisdnMap[key];
      this.$delete(this.originalMsisdnMap, key);
    }
    this.$set(item, 'onEdit', false);
    if (this.editingId === key) this.editingId = null;
  }

  async created(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: 'Viewing',
        action_status: 'success',
        object_type: 'Page',
        addititional_info: getTranslatedParams({ id: this.$route.params.id })
      };
      await this.actionLog(this.logObject);
      const data = await this.actionGetPoolNumbers({ id: Number(this.$route.params.id) });
      if (data.length === 0) {
        notifyWarning()
      }
    } catch (e) {
      await this.actionLog({ ...this.logObject, action_status: 'failed' });
      notifyError(e);
    }
  }
}
